<template>
  <div>
    <WorkCalendar ref="workCalendarTemplate" :options="calendarOptions"/>
  </div>
</template>
<script>
import WorkCalendar from '@/plugin/WorkCalendarTemplate';
import TaskData from "@/assets/models/work-calendar/TaskData";
import Holiday from "@/assets/models/work-calendar/holiday";
import Workday from "@/assets/models/work-calendar/workday";
// import dayjs from 'dayjs'

export default {
  components: {
    WorkCalendar
  },
  data() {
    return {
      calendarOptions: {
        TaskData: TaskData,
        Holiday: Holiday,
        Workday: Workday
      },
    }
  },
  mounted() {
    // dayjs().format();
  }
}
</script>
